<template>
  <div class="user-center-container depth-4">
      <div class="user-center__header">
          <div class="back-icon" @click="handleGoBack">
              <icon name="arrow-left" />
          </div>
          <div class="main-title">{{ $route.meta.title }}</div>
      </div>
      <div class="p-md">
        <van-tabs v-model="curTab">
          <van-tab title="待领取">
            <div class="card-container">
              <div
                class="card"
                v-for="item in oneList"
                :key="item.id"
              >
                <div class="card-left">
                  <div class="left-body">
                    <div class="left-money orange">
                      <span>{{ item.discount_money }}</span>
                      <span class="currency">元</span>
                    </div>
                    <div class="left-tip">满{{ item.condition }}减{{ item.discount_money }}</div>
                  </div>
                </div>
                <div class="card-right">
                  <div>
                    <span class="right-title">{{ item.describe }}</span>
                    <van-tag v-if="item.coupon_type == 2" type="warning" size="medium">新人券</van-tag>
                    <van-tag v-if="item.coupon_type == 1" type="success" size="medium">普通券</van-tag>
                  </div>
                  <div class="right-time">
                    {{ item.receive_stime }}
                    -
                    {{ item.receive_etime }}
                  </div>
                  <div>
                    <van-button color="#c49947" type="warning" size="small" round @click="doActive(item)">
                      领取优惠券
                    </van-button>
                  </div>
                </div>
              </div>
              <div class="b-text">-- 已经到底了 --</div>
            </div>
          </van-tab>
          <van-tab title="已领取">
            <div class="card-container">
              <div
                class="card"
                v-for="item in twoList"
                :key="item.id"
              >
                <div class="card-left">
                  <div class="left-body">
                    <div class="left-money orange">
                      <span>{{ item.discount_money }}</span>
                      <span class="currency">元</span>
                    </div>
                    <div class="left-tip">满{{ item.condition }}减{{ item.discount_money }}</div>
                  </div>
                </div>
                <div class="card-right">
                  <div>
                    <span class="right-title">{{ item.describe }}</span>
                    <van-tag v-if="item.coupon_type == 2" type="warning" size="medium">新人券</van-tag>
                    <van-tag v-if="item.coupon_type == 1" type="success" size="medium">普通券</van-tag>
                  </div>
                  <div class="right-time" v-if="item.coupon_type == 1">
                    {{ item.effective_etime }}
                  </div>
                  <div class="right-time" v-if="item.coupon_type == 2">
                    {{ item.effective_day || item.effective_etime }}后到期
                  </div>
                </div>
              </div>
              <div class="b-text">-- 已经到底了 --</div>
            </div>
          </van-tab>
          <van-tab title="已使用">
            <div class="card-container">
              <div
                class="card gray"
                v-for="item in threeList"
                :key="item.id"
              >
                <div class="card-left">
                  <div class="left-body">
                    <div class="left-money">
                      <span>{{ item.discount_money }}</span>
                      <span class="currency">元</span>
                    </div>
                    <div class="left-tip">满{{ item.condition }}减{{ item.discount_money }}</div>
                  </div>
                </div>
                <div class="card-right">
                  <div>
                    <span class="right-title">{{ item.describe }}</span>
                    <van-tag v-if="item.coupon_type == 2" type="warning" size="medium">新人券</van-tag>
                    <van-tag v-if="item.coupon_type == 1" type="success" size="medium">普通券</van-tag>
                  </div>
                  <div class="right-time" v-if="item.coupon_type == 1">
                    {{ item.effective_etime }}
                  </div>
                  <div class="right-time" v-if="item.coupon_type == 2">
                    {{ item.effective_day || item.effective_etime }}
                  </div>
                </div>
              </div>
              <div class="b-text">-- 已经到底了 --</div>
            </div>
          </van-tab>
          <van-tab title="已过期">
            <div class="card-container">
              <div
                class="card gray"
                v-for="item in fourList"
                :key="item.id"
              >
                <div class="card-left">
                  <div class="left-body">
                    <div class="left-money">
                      <span>{{ item.discount_money }}</span>
                      <span class="currency">元</span>
                    </div>
                    <div class="left-tip">满{{ item.condition }}减{{ item.discount_money }}</div>
                  </div>
                </div>
                <div class="card-right">
                  <div>
                    <span class="right-title">{{ item.describe }}</span>
                    <van-tag v-if="item.coupon_type == 2" type="warning" size="medium">新人券</van-tag>
                    <van-tag v-if="item.coupon_type == 1" type="success" size="medium">普通券</van-tag>
                  </div>
                  <div class="right-time" v-if="item.coupon_type == 1">
                    {{ item.effective_etime }}
                  </div>
                  <div class="right-time" v-if="item.coupon_type == 2">
                    {{ item.effective_day || item.effective_etime }}
                  </div>
                </div>
              </div>
              <div class="b-text">-- 已经到底了 --</div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUserDetail, activeCouponReq } from '@/service'
import { 
  Icon, Tabs as VanTabs,
  Tab as VanTab,
  Tag as VanTag,
  Button as VanButton,
} from 'vant'

/** 优惠券列表 */
export default {
  name: 'CouponList',
  components: {
    Icon,
    VanTabs,
    VanTab,
    VanTag,
    VanButton,
  },
  data() {
      return {
        curTab: 0,
        oneList: [],
        twoList: [],
        threeList: [],
        fourList: [],
        countdown: null,
      }
  },
  computed: {
      ...mapState({
          app: state => state.app,
          userDetail: state => state.user.userDetail,
      }),
  },
  watch: {
    curTab() {
      this.doGetCouponList()
    }
  },
  methods: {
      handleGoBack() {
        history.back()
      },
      doActive(item) {
        const params = { coupon_id: item.id }
        activeCouponReq(params).then((res) => {
          if (`${res?.code}` === '0') {
            this.$toast.success('领取成功')
            this.doGetCouponList()
          } else {
            this.$toast(res?.msg || '领取失败')
          }
        }).catch(() => {
          this.$toast('领取失败')
        })
      },
      countdownTime(timeStr) {
        try {
          if (!timeStr) return timeStr ?? ''
          // Split the input time string into hours, minutes, and seconds
          let parts = timeStr.split(':');
          let hours = parseInt(parts[0], 10);
          let minutes = parseInt(parts[1], 10);
          let seconds = parseInt(parts[2], 10);

          // Convert the time to total seconds
          let totalSeconds = hours * 3600 + minutes * 60 + seconds;

          // Subtract one second if totalSeconds is greater than zero
          if (totalSeconds > 0) {
              totalSeconds -= 1;
          } else {
              totalSeconds = 0; // Ensure time does not go negative
          }

          // Convert total seconds back to hours, minutes, and seconds
          let newHours = Math.floor(totalSeconds / 3600);
          totalSeconds %= 3600;
          let newMinutes = Math.floor(totalSeconds / 60);
          let newSeconds = totalSeconds % 60;

          // Format the result with leading zeros
          let result = [
              String(newHours).padStart(2, '0'),
              String(newMinutes).padStart(2, '0'),
              String(newSeconds).padStart(2, '0'),
          ].join(':');

          return result;
        } catch (err) {
          return timeStr ?? ''
        }
      },
      doGetCouponList() {
        if (this.countdown) {
          clearInterval(this.countdown) // 清除倒计时
        }
        getUserDetail().then((res) => {
          let resList = []
          if (`${res?.code}` === '0') {
            resList = res?.data?.coupon || []
          } else {
            this.$toast(res?.msg || '获取优惠券失败')
          }
          if (resList instanceof Array && resList.length > 0) {
            const oneList = []
            const twoList = []
            const threeList = []
            const fourList = []
            resList.forEach((d) => {
              if (d.coupon_status == 1) oneList.push(d)
              if (d.coupon_status == 2) twoList.push(d)
              if (d.coupon_status == 3) threeList.push(d)
              if (d.coupon_status == 4) fourList.push(d)
            })
            this.oneList = oneList
            this.twoList = twoList
            this.threeList = threeList
            this.fourList = fourList
            if (twoList?.length > 0) {
              // 显示倒计时
              this.countdown = setInterval(() => {
                twoList.forEach((d, idx) => {
                  if (d.coupon_status == 2 && d.coupon_type === 2) {
                    this.twoList[idx].effective_etime = this.countdownTime(this.twoList[idx].effective_etime)
                  }
                })
              }, 1000)
            }
          }
        }).catch(() => {
          this.$toast('获取优惠券失败')
        })
      }
  },
  mounted() {
    this.doGetCouponList()
  },
}
</script>

<style scoped lang="scss">
.user-center__header {
  background-color: var(--theme-color);
  color: $white;
  padding: 12px;
  position: relative;
  display: flex;
  flex-direction: row;

  .back-icon {
      display: block;
      float: left;
  }

  .main-title {
      text-align: center;
      flex: 1;
  }
}

.user-center-container {
  background-color: #eeeeee;
  height: 100%;
  position: relative;
}

.card-container {
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.card {
  display: flex;
  flex-direction: row;
  padding: 12px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 12px;
  font-size: 14px;
}

.card-left {
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #d6d6d6;
  padding: 8px;
}

.left-body {
  text-align: center;
}

.left-money {
  font-size: 36px;
  font-weight: bold;
}

.currency {
  font-size: 20px;
}

.left-tip {
  font-size: 16px;
}

.card-right {
  flex: 1;
  padding: 8px 20px;
}

.right-title {
  font-weight: bold;
  font-size: 15px;
  margin-right: 6px;
}

.right-time {
  margin: 6px 0;
}

.b-text {
  text-align: center;
  font-size: 14px;
  line-height: 50px;
  color: gray;
}

.gray {
  color: gray;
}

.orange {
  color: #c49947;
}
</style>
